import { getSiteLangFromOtGeoQuerystring } from "./getSiteLangFromOtGeoQuerystring.js";
import { getSiteLangFromGeoLocation } from "./getSiteLangFromGeoLocation.js";
import { getSiteLangFromGeoLocationExtendedRegion } from "./getSiteLangFromGeoLocationExtendedRegion.js";
import { getSiteLangFromBrowserLanguage } from "./getSiteLangFromBrowserLanguage.js";
import { ComputedValueGetter, type ICalculatedValueGetter } from "../../../utils/ComputedValueGetter.js";
import { getInferredSiteLang } from "./getInferredSiteLang.js";
import type { LanguageCountryLocale } from "../../../types-and-definitions/locale-defs/Locales.js";
import type { Nil } from "@mcwd/typescript-type-guards";

const InferredSiteLangValueGetter = new ComputedValueGetter({
  isLazy: true,
  computeFn: getInferredSiteLang
});

export const InferredSiteLang =
  Object.assign(
    InferredSiteLangValueGetter,
    {
      calculateFromOtGeoQuerystring: getSiteLangFromOtGeoQuerystring,
      calculateFromGeoLocation: getSiteLangFromGeoLocation,
      calculateFromGeoLocationExtendedRegion: getSiteLangFromGeoLocationExtendedRegion,
      calculateFromBrowserLanguage: getSiteLangFromBrowserLanguage
    } as const
  ) satisfies {
    calculateFromOtGeoQuerystring (): LanguageCountryLocale | Nil;
    calculateFromGeoLocation (): LanguageCountryLocale | Nil;
    calculateFromGeoLocationExtendedRegion (): LanguageCountryLocale | Nil;
    calculateFromBrowserLanguage (): LanguageCountryLocale | Nil;
  } & ICalculatedValueGetter<LanguageCountryLocale | Nil, LanguageCountryLocale | Nil>;
